<template lang="pug">
  div.login
    form.login__center(@submit.prevent="onSubmit")
      h1.login__title.bold {{loginHeadText}}
      div.login__fields
        input.login__input.bold(type="text" name="username" v-model="username" :placeholder="$translate('Логин')" required minlength=2)
        input.login__input.bold(type="password" name="password" v-model="password" :placeholder="$translate('Пароль')" required minlength=2)
      button.login__submit.reset-btn(type="submit" :disabled="loading") {{loading ? $translate('Загрузка...') : $translate('Вход')}}
      transition(name="fade")
        div.login__errors(v-if="error")
          span {{error}}
      div.login__actions
        router-link.login__actions-link(
          :to="{path: 'request-reset-password'}"
        ) {{forgotPasswordText}}
      div.login__links
        .login__item
          router-link.login__link(
            :to="{name: 'geo.objects'}"
          ) {{ $translate('Публичная карта объектов') }}
          button.reset-btn.button_icon.button_share(
            type="button"
            title='Копировать ссылку'
            @click='copyUrl'
          )
        .login__item
          router-link.login__link(
            :to="{name: 'geo.treads'}"
          ) {{ publicSchemaText }}
          button.reset-btn.button_icon.button_share(
            type="button"
            title='Копировать ссылку'
            @click='copyUrl'
          )
        a.login__link(
          v-if="customPublicFilesLink"
          :href="customPublicFilesLink"
          target="_blank"
        ) {{ $translate('Материалы территориальной схемы') }}
        router-link.login__link(
          v-else
          :to="{name: 'publicFilesAll.files'}"
          target="_blank"
        ) {{ $translate('Материалы территориальной схемы') }}

</template>

<script>
import loginFormMixin from './mixins/login-form'
import { REGION_CONFIG } from '@/config/regions'
import textMixin from '@/mixins/text-mixin'

export default {
  name: 'login',
  mixins: [loginFormMixin, textMixin],
  computed: {
    customPublicFilesLink() {
      return this.$translate(REGION_CONFIG.customPublicFilesLink)
    },
  },
  created() {
    if (this.$route.query.max_number_of_sessions_exceeded) {
      alert('Сессия завершена. Превышен лимит количества параллельных сессий.')
    }
  },
}
</script>
